import { create } from 'zustand';
import { DashboardState, Subscription, Chatbot, ChatMetrics, Invoice } from '../types';
import { apiService } from '../services/api';

interface DashboardStore extends DashboardState {
  fetchMetrics: () => Promise<void>;
  fetchSubscription: () => Promise<void>;
  fetchChatbot: () => Promise<void>;
  fetchInvoices: () => Promise<void>;
  updateSubscription: (subscription: Subscription) => void;
  updateChatbot: (chatbot: Chatbot) => void;
  setLoading: (loading: boolean) => void;
}

export const useDashboardStore = create<DashboardStore>((set, get) => ({
  metrics: null,
  subscription: null,
  chatbot: null,
  invoices: [],
  isLoading: false,

  fetchMetrics: async () => {
    set({ isLoading: true });
    try {
      const response = await apiService.getMetrics();
      if (response.success && response.data) {
        set({ metrics: response.data, isLoading: false });
      } else {
        set({ isLoading: false });
      }
    } catch (error) {
      set({ isLoading: false });
    }
  },

  fetchSubscription: async () => {
    set({ isLoading: true });
    try {
      const response = await apiService.getSubscription();
      if (response.success && response.data) {
        set({ subscription: response.data, isLoading: false });
      } else {
        set({ isLoading: false });
      }
    } catch (error) {
      set({ isLoading: false });
    }
  },

  fetchChatbot: async () => {
    set({ isLoading: true });
    try {
      const response = await apiService.getChatbot();
      if (response.success && response.data) {
        set({ chatbot: response.data, isLoading: false });
      } else {
        set({ isLoading: false });
      }
    } catch (error) {
      set({ isLoading: false });
    }
  },

  fetchInvoices: async () => {
    set({ isLoading: true });
    try {
      const response = await apiService.getInvoices();
      if (response.success && response.data) {
        set({ invoices: response.data, isLoading: false });
      } else {
        set({ isLoading: false });
      }
    } catch (error) {
      set({ isLoading: false });
    }
  },

  updateSubscription: (subscription: Subscription) => {
    set({ subscription });
  },

  updateChatbot: (chatbot: Chatbot) => {
    set({ chatbot });
  },

  setLoading: (loading: boolean) => {
    set({ isLoading: loading });
  },
}));